import { jsxs, jsx } from 'react/jsx-runtime';
import * as Ariakit from '@ariakit/react';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmOptions, IconLlmCheck } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-context.module.scss.js';

const PageContext = () => {
  const label = useLabel();
  const contexts = useLlm(state => state.contexts);
  const currentContext = useLlm(state => state.currentContext);
  const {
    setCurrentContext
  } = useLlm(state => state.actions);
  const hasContexts = contexts && contexts.length > 1;
  const onSelect = context => {
    setCurrentContext(context);
  };
  return hasContexts && jsxs(Ariakit.MenuProvider, {
    children: [jsx(Ariakit.MenuButton, {
      render: jsx("button", {
        type: "button",
        className: getClassNames(style.options),
        "aria-label": label('llm.tone'),
        children: jsx(IconLlmOptions, {})
      })
    }), jsxs(Ariakit.Menu, {
      portal: true,
      className: getClassNames(style.context),
      children: [jsx(Ariakit.MenuHeading, {
        className: getClassNames(style.title),
        children: "Chi sei?"
      }), jsx(Ariakit.MenuGroup, {
        className: getClassNames(style.items),
        children: contexts.map((context, i) => jsxs(Ariakit.MenuItem, {
          className: getClassNames(style.item),
          "data-active-item": context === currentContext,
          onClick: () => onSelect(context),
          children: [context.title, " ", context === currentContext && jsx(IconLlmCheck, {})]
        }, `context-${i}`))
      })]
    })]
  });
};

export { PageContext };
//# sourceMappingURL=page-context.js.map
